import { useState, useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";
import api from "@helpers/api";

import { useCommunity } from "@contexts/CommunityContext";

import CustomModal from "@components/CustomModal";
import ImageImportTool from "@components/ImageImportTool";
import AvailabilityInPlan from "@components/AvailabilityInPlan";

import { Input, Text, Button } from "@fragments";


import * as Material from "@mui/material";

import {
  BackupRounded,
  DeleteRounded,
  SellRounded,
  TuneRounded,
  WallpaperRounded,
} from "@mui/icons-material";

import './styles.css'

export default function ManageMaterialModal({ modalRef }) {
  const REF_config = useRef({});
  const REF_callback = useRef();
  const REF_community = useRef({})

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();


  const { loadCommunities, community } = useCommunity();


  modalRef.current = {
    open(preFill, callback) {

      console.log('open edit', preFill)

      REF_config.current = {
        ...preFill,
        community: preFill.community?.id || preFill.community
      };

      REF_community.current = {
        ...community.get(preFill.community?.id || preFill.community)
      }

      REF_callback.current = callback;
      console.log(preFill);
      setOpen(true);
      setError(null)
    },
  };

  async function handleSubmit() {
    try {
      const payload = getPayload();

      if ((!payload.material_base64) && (!REF_config.current.path)) {
        setError('Insira um material para continuar')
        return
      }

      if (!payload.name) {
        setError('Insira o título do material para continuar')
        return
      }

      setLoading(true);

      const { data } = await api[payload.id ? 'patch' : 'post']("material", payload);

      if (data.id) {
        await REF_callback.current(data);
        setOpen(false);
      }
    } catch (e) {
      console.log(e);
      setError('Um erro ocorreu ao salvar o material, confira o arquivo inserido e tente novamente')
    }

    setLoading(false);

    function getPayload() {
      const {
        id,
        name,
        banner_base64,
        material_base64,
        availability,
      } = REF_config.current;

      console.log(REF_config.current)

      const data = {
        community: parseInt(REF_config.current.community),
        name: name?.trim(),
        availability: availability || ['all'],
      };

      if (!!id) {
        data.id = id;
      }

      if (!!banner_base64 && !banner_base64?.startsWith("http")) {
        data.banner_base64 = banner_base64;
      }

      if (!!material_base64 && !material_base64?.startsWith("http")) {
        data.material_base64 = material_base64;
        data.type = 'PDF'
      }

      return data;
    }
  }

  async function handleDelete() {
    try {
      const { data } = await api.delete("material?id=" + REF_config.current.id);
    } catch (e) {
      console.log(e);
    }

    REF_callback.current()

    setOpen(false);
  }

  function handleAvailabilityChange(result) {
    REF_config.current.availability = [...result];
  }

  function General() {
    const [materialBase64, setMaterialBase64] = useState();
    const [fileInfo, setFileInfo] = useState(null);

    function UploadSection() {
      const MAX_BYTES = 100 * 1024 * 1024; // 100MB
      const fileInputRef = useRef(null);

      // Estado para controlar se já existe um arquivo no material
      const [hasExistingFile, setHasExistingFile] = useState(() => !!REF_config.current.path);

      function formatBytes(bytes) {
        if (!bytes && bytes !== 0) return "";
        const units = ["B", "KB", "MB", "GB"]; // sufficient for this case
        let size = bytes;
        let unitIndex = 0;
        while (size >= 1024 && unitIndex < units.length - 1) {
          size /= 1024;
          unitIndex += 1;
        }
        return `${size.toFixed(size >= 100 ? 0 : size >= 10 ? 1 : 2)} ${units[unitIndex]}`;
      }

      function invalidFileMessage(message) {
        // Simple alert to keep consistent with rest of UI behavior
        window.alert(message);
      }

      function validatePdf(file) {
        const isPdfByType = file?.type === "application/pdf";
        const isPdfByName = typeof file?.name === "string" && file.name.toLowerCase().endsWith(".pdf");
        if (!(isPdfByType || isPdfByName)) {
          invalidFileMessage("Apenas arquivos PDF são permitidos.");
          return false;
        }
        if (file.size > MAX_BYTES) {
          invalidFileMessage("O arquivo excede o limite de 100MB.");
          return false;
        }
        return true;
      }

      function handleSelectedFile(file) {
        if (!file) return;
        if (!validatePdf(file)) return;

        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result; // data URL
          setMaterialBase64(result);
          setFileInfo({ name: file.name, size: file.size });
          setHasExistingFile(false);
          // Update external config refs
          REF_config.current.material_base64 = result;
          REF_config.current.type = 'PDF';
        };
        reader.onerror = () => {
          invalidFileMessage("Falha ao ler o arquivo. Tente novamente.");
        };
        reader.readAsDataURL(file);
      }

      function handleInputChange(e) {
        const file = e?.target?.files?.[0];
        handleSelectedFile(file);
        // Clear input so selecting the same file again re-triggers change
        if (e?.target) e.target.value = null;
      }

      function handleDrop(e) {
        e.preventDefault();
        const file = e.dataTransfer?.files?.[0];
        handleSelectedFile(file);
      }

      function handleDragOver(e) {
        e.preventDefault();
      }

      function removeFile() {
        REF_config.current.material_base64 = undefined;
        REF_config.current.type = undefined;

        setMaterialBase64(undefined);
        setFileInfo(null);
        setHasExistingFile(false);
      }

      function removeExistingFile() {
        REF_config.current.path = undefined;
        setHasExistingFile(false);
      }

      // Se já existe um arquivo no material
      if (hasExistingFile) {
        const fileName = REF_config.current.path?.split('/').pop() || 'Arquivo existente';

        return (
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: 8,
                padding: 12,
                marginTop: 8,
              }}
              className="bsf-9"
            >
              <Text.span>{fileName}</Text.span>
              <Button color="overlay" onClick={removeExistingFile} icon={<DeleteRounded />} />
            </div>
          </div>
        );
      }

      return (
        <div>
          {!fileInfo ? (
            <div
              onDrop={handleDrop}
              onDragOver={handleDragOver}
              style={{
                border: "2px dashed #cfd8dc",
                borderRadius: 8,
                padding: 16,
                textAlign: "center",
                background: "#fafafa",
              }}
              className="mt-2"
            >
              <div style={{ marginBottom: 8 }}>
                Arraste e solte o PDF aqui, ou
              </div>
              <input
                ref={fileInputRef}
                type="file"
                accept="application/pdf,.pdf"
                onChange={handleInputChange}
                style={{ display: "none" }}
              />
              <Material.Button variant="contained" size="small" onClick={() => fileInputRef.current?.click()}>
                Selecionar arquivo
              </Material.Button>
              <div style={{ marginTop: 8, color: "#607d8b", fontSize: 12 }}>
                Apenas PDF • até 100MB
              </div>
            </div>
          ) : null}

          {fileInfo ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                border: "1px solid #e0e0e0",
                borderRadius: 8,
                padding: 12,
                marginTop: 12,
                background: "white",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ fontWeight: 600 }}>{fileInfo.name}</div>
                <div style={{ color: "#607d8b", fontSize: 12 }}>{formatBytes(fileInfo.size)}</div>
              </div>
              <Material.IconButton aria-label="Remover" onClick={removeFile}>
                <DeleteRounded />
              </Material.IconButton>
            </div>
          ) : null}
        </div>
      );
    }

    return (
      <>
        <Text.h3 icon={<BackupRounded />} className="mt-3" value="Arquivo do material (Formato PDF)" />

        <UploadSection />

        <Text.h3 icon={<WallpaperRounded />} className="mt-3" value="Banner do material (Formato A4)" />

        <div className="banner-add mt-2 mb-3">
          <ImageImportTool
            aspectRatio={1 / 1.4142}
            size={160}
            imageMaxWidth={720}
            src={REF_config.current.banner_base64 || REF_config.current.banner}
            onCrop={(imageBase64) => {
              REF_config.current.banner_base64 = imageBase64;
            }}
            title="Redimensionar banner do material"
          />
        </div>

        <Text.h3 left={<TuneRounded />} value="Configurações gerais" />

        <Input.Text
          placeholder="Nome do material"
          value={REF_config.current.name}
          onInput={(v) => {
            REF_config.current.name = v;
          }}
          label="Insira o nome do material"
          size={50}
        />
      </>
    );
  }
  function Availability() {
    return (
      <>
        <Text.h6 icon={<SellRounded />} value="Material disponível nos planos" />

        <AvailabilityInPlan
          community={REF_config.current?.community}
          initialValues={REF_config.current?.availability}
          onChange={handleAvailabilityChange}
          className="mt-1"
        />
      </>
    );
  }

  return (
    <CustomModal
      maxWidth={550}
      bottomButtonSumbitText="Salvar material"
      bottomButtonCancelText="Cancelar"
      loading={loading}
      handleDelete={REF_config.current?.id && handleDelete}
      deletionTitle="Você realmente deseja apagar este material permanentemente?"
      title={REF_config.current?.id ? "Editar material" : "Criar novo material"}
      handleSubmit={handleSubmit}
      open={open}
      handleClose={() => setOpen(false)}
      bodyComponent={
        open ? (
          <div className="px-4 py-1">
            <General />

            <Availability />

            {
              error && <Material.Alert severity="error" className="mt-3 mb-5">
                {
                  error
                }
              </Material.Alert>
            }
          </div>
        ) : null
      }
    />
  );
}
